import { DealerModel } from './dealer'
import { Managers } from './area'
import { AddressModel } from './address'

export const MembersOrderBy: {
  [key: string]: string;
} = {
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT',
  id: 'ID',
  nickname: 'NICKNAME',
  uniqueId: 'UNIQUEID'
}

export interface MemberModel {
  id: number;
  addresses: AddressModel[];
  dealer: DealerModel | null;
  managers: Managers;
  nickname: string | null;
  profilePhtoto: string | null;
  uniqueId: string;
  createdAt: string;
  updatedAt: string;
}
